import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useContext } from 'react';
import { framerFade, interactiveScale } from 'utilities/FramerAnimations';
import './SparkItem.module.scss';
import { ReflectionItemContext } from 'pages/Growth/Reflect/components/ReflectionItem/ReflectionItem';
import { useRedux } from 'hooks/useRedux';

type SparkItemProps = {
  item: SparkEntity;
  readOnly?: boolean;
  setSparkLinkModalIsOpen?: (isOpen: boolean) => void;
  getSparkName?: (id: number) => void;
};

export default function SparkItem({
  item,
  readOnly,
  setSparkLinkModalIsOpen,
  getSparkName,
}: SparkItemProps) {
  const { handleClick } = useContext(ReflectionItemContext);
  function onClick() {
    if ((item.done || item.notInGoals) && handleClick) {
      handleClick(item.id);
      return;
    }

    if (
      setSparkLinkModalIsOpen &&
      !item.done &&
      !item.notInGoals &&
      getSparkName
    ) {
      getSparkName(item.id);
      setSparkLinkModalIsOpen(true);
    }
  }

  const skill = useRedux((state) => state.skill?.entities.byId[item.skill_id]);
  console.log('skill', skill);

  return (
    <motion.div
      styleName={`item ${item.done || item.notInGoals ? skill?.type : ''}`}
      {...interactiveScale}
      onClick={onClick}
      style={{ pointerEvents: readOnly ? 'none' : 'all' }}
    >
      {!item.notInGoals && (
        <div styleName="check-circle ">
          {!!item.done && (
            <motion.div {...framerFade}>
              <FontAwesomeIcon icon={faCheck} />
            </motion.div>
          )}
        </div>
      )}
      <p>{item.name}</p>
    </motion.div>
  );
}
